import { Props_SnippetArticlesCarousel } from "./ArticlesCarousel.props"
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, A11y, EffectFade, Pagination } from 'swiper/modules'
import SnippetLink from "../Shared/Link/Link"
import SwiperControls, { swiperNavigationOptions, swiperPaginationOptions } from '../Shared/SwiperControls/SwiperControls'
import { Legacy_CompileMarkdown } from "../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler"

const SnippetArticlesCarousel = (props: Props_SnippetArticlesCarousel) => {
    const { heading, repeatable_articlesCarouselOptions } = props;
    const carouselId = "articles-carousel"

    return (
        <section className="snippet-articles-carousel">
            <div className="snippet-articles-carousel__container">
                <h2 className={`snippet-articles-carousel__heading ${heading.visibility?.value ? '' : 'snippet-articles-carousel__heading--hidden'}`}>{ heading.content?.value }</h2>
                <Swiper
                    className="snippet-articles-carousel__swiper"
                    modules={[Navigation, EffectFade, Pagination, A11y]}
                    navigation={{
                        ...swiperNavigationOptions,
                        prevEl: `.swiper-navigation__button-prev-${carouselId}`,
                        nextEl: `.swiper-navigation__button-next-${carouselId}`,
                    }}
                    pagination={{
                        ...swiperPaginationOptions,
                        clickable: true,
                        dynamicBullets: false,
                        el: `.swiper-pagination-${carouselId}`,
                    }}
                    slidesPerView={1}
                    fadeEffect={{ crossFade: true }}
                    effect="fade"
                >
                    {repeatable_articlesCarouselOptions && repeatable_articlesCarouselOptions.map((item, index) => (
                        <SwiperSlide key={index} className="snippet-articles-carousel__slide">
                            <div className="snippet-articles-carousel__card">
                                {item.image && (
                                    <img
                                        src={item.image.value}
                                        alt={item.imageAltText?.value || `Article ${index + 1}`}
                                        className="snippet-articles-carousel__card-image"
                                    />
                                )}
                                <div className="snippet-articles-carousel__card-content">
                                    {item.title.value && (
                                        <h3 className="snippet-articles-carousel__card-title">{item.title.value}</h3>
                                    )}
                                    {item.content.value && (
                                        <div className="snippet-articles-carousel__card-description">{Legacy_CompileMarkdown(item.content.value)}</div>
                                    )}
                                    {item.linkHref.value && (
                                        <SnippetLink
                                            url={item.linkHref.value}
                                            linkStyles={item.linkStyle?.value}
                                            openInNewTab={!!item.linkTarget?.value}
                                            className="snippet-articles-carousel__card-link"
                                        >
                                            {item.linkText?.value}
                                        </SnippetLink>
                                    )}
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                    <SwiperControls 
                        uniqueId={carouselId}
                        className="snippet-articles-carousel__navigation"
                        showNavigation
                        showPagination
                    />
                </Swiper>
            </div>
        </section>
    )
}

export default SnippetArticlesCarousel
